module.exports = __webpack_public_path__ + "img/shixiao_mobile_poster.c9040ee0.jpg";